module.exports = __webpack_public_path__ + "static/img/092.ce83219.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/092.png
// module id = sbDn
// module chunks = 0